import { render, staticRenderFns } from "./noticeadd.vue?vue&type=template&id=65e713a4&scoped=true&"
import script from "./noticeadd.vue?vue&type=script&lang=js&"
export * from "./noticeadd.vue?vue&type=script&lang=js&"
import style0 from "./noticeadd.vue?vue&type=style&index=0&id=65e713a4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65e713a4",
  null
  
)

export default component.exports